import Image from "@tiptap/extension-image"
import { mergeAttributes } from "@tiptap/core"

export const ResizableImage = Image.extend({
  name: "image",

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => {
          if (!attributes.style) return {}
          return { style: attributes.style }
        },
      },
      "data-ocr-type": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-ocr-type"),
        renderHTML: (attributes) => {
          if (!attributes["data-ocr-type"]) return {}
          return { "data-ocr-type": attributes["data-ocr-type"] }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "img[src]",
        getAttrs: (element) => {
          if (!(element instanceof HTMLElement)) return false
          if (element.getAttribute("data-content-type")) return false
          return {}
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const { width, height, style, ...rest } = HTMLAttributes
    const sizeStyle = [
      width ? `width:${width}px` : "",
      height ? `height:${height}px` : "",
    ]
      .filter(Boolean)
      .join(";")
    const mergedStyle = [style, sizeStyle].filter(Boolean).join(";")

    return [
      "img",
      mergeAttributes(this.options.HTMLAttributes, rest, {
        class: "tiptap-editor__image",
        ...(width ? { width } : {}),
        ...(height ? { height } : {}),
        ...(mergedStyle ? { style: mergedStyle } : {}),
      }),
    ]
  },
})
